import { Injectable, EventEmitter } from '@angular/core';
import { timer } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';

export interface IToast {
  type: EToastType;
  message: string | SafeHtml;
  UUID: number;
}

export enum EToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info'
}


@Injectable({
  providedIn: 'root',
})
export class HaloToastService {
  public add: EventEmitter<IToast> = new EventEmitter();
  public remove: EventEmitter<number> = new EventEmitter();

  constructor() {}

  generateUUID(): number {
    return new Date().getTime() / 1000 + Math.random();
  }

  creatToast(message: string | SafeHtml, type: EToastType = EToastType.SUCCESS,  timeout: number = 2500) {
    if (!message) return;

    let _UUID = this.generateUUID();
    let _toast: IToast = { type: type, message: message, UUID: _UUID };
    this.add.emit(_toast);

    // if timeout is 0 toast should visible untill user close that.
    if (timeout !== 0) {
      this.autoClose(_UUID, timeout);

    }
    return _UUID;
  }

  autoClose(UUID:number, timeout:number) {
    const _timer = timer(timeout).subscribe(res => {
      this.remove.emit(UUID);
      _timer.unsubscribe();
    });
  }
}
